import React, { createContext, ReactNode, useMemo } from 'react'
import VodItem from '@/features/VOD/vodClasses/vodItem'
import { useItemFetcher } from '@/features/VOD/hooks/useItemFetch'
import { useVodItems } from '../../hooks/useVodItems'

interface VodItemsContextType {
    rowItems: VodItem[]
    getItems: (rowId?: string) => Promise<VodItem[]>
    setRowItems: (items: VodItem[]) => void
    isLoading: boolean
    isError: boolean
}

export const VodItemsContext = createContext<VodItemsContextType | undefined>(
    undefined
)

export const VodItemsProvider: React.FC<{
    productId: string
    children: ReactNode
}> = ({ productId, children }) => {
    const { rowItems, getItems, setRowItems, isLoading, isError } =
        useVodItems(productId)

    useItemFetcher(productId, setRowItems, getItems)
    const contextValue = useMemo(
        () => ({
            rowItems,
            getItems,
            setRowItems,
            isLoading,
            isError,
        }),
        [rowItems, isLoading, isError]
    )
    return (
        <VodItemsContext.Provider value={contextValue}>
            {children}
        </VodItemsContext.Provider>
    )
}
